import React from "react";
import {
  TextField,
  Autocomplete
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import moment from "moment";
import contractStatus from "../../../../constants/contractStatus";

const MainSelectContract = ({ statistic, statistics, onChange }) => {
  const classes = useStyles();

  const handleChange = (event, value) => {
    if (!value) return
    onChange(value)
  }

  const _renderOption = (params) => {
    return (
      <div
        {...params}
        dangerouslySetInnerHTML={{__html: params.key}}
      />
    )
  }
  const _renderValue = (option, params) => {
    const status = contractStatus[String(option?.available_contracts?.status)];
    const elStatus = `<span style="padding: 6px 12px; border-radius: 10px; font-size: 14px; line-height: 16px; margin-left: 8px; background: ${status.colorBg}; color: ${status.colorTx};">${ status.label }</span>`
    return (
      <span
        {...params}
        style={{padding: "0 10px", position: "absolute", pointerEvents: "none"}}
        dangerouslySetInnerHTML={{
          __html: `№ ${option?.available_contracts?.number} от ${moment(option?.available_contracts?.date).format('DD.MM.YYYY')} - ${elStatus}`
        }}
      />
    );
  }
  const _getOptionLabel = (option) => {
    const status = contractStatus[String(option?.available_contracts?.status)];
    const elStatus = `<span style="padding: 6px 12px; border-radius: 10px; font-size: 14px; line-height: 16px; margin-left: 8px; background: ${status.colorBg}; color: ${status.colorTx};">${ status.label }</span>`
    return `№ ${option?.available_contracts?.number} от ${moment(option?.available_contracts?.date).format('DD.MM.YYYY')} - ${elStatus}`;
  }

  return (
    <Autocomplete
      value={statistic}
      options={statistics}
      fullWidth={true}
      size="small"
      className={classes.root}
      sx={{minWidth: 360}}
      getOptionLabel={_getOptionLabel}
      renderOption={_renderOption}
      renderValue={_renderValue}
      renderInput={(params) => (
        <TextField
          {...params}
        />
      )}
      onChange={handleChange}
    />
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiInputBase-root": {
      background: "white"
    }
  }
}));

export default MainSelectContract
